module.exports = __webpack_public_path__ + "img/compact.659c6783.png";